// Which Storyblok datasources a page fetches during SSR. Shared with the Storyblok webhook
// (server/webhooks/storyblok-refresh.js, via the SSR bundle) so a datasource update regenerates
// exactly the static HTML that depends on it.

// Indirect: its `products` entry lists the real datasources (product1, product2, …).
export const PRODUCTS_DATASOURCE = 'products';

// LandingPage.duck fetchProducts
export const LANDING_PAGE_DATASOURCES = [PRODUCTS_DATASOURCE];

const BLOG_DATASOURCE = 'blog-pass-preset';

const byComponent = (components, name) => components.filter((gc) => gc?.component === name);

/**
 * Preset blocks of a story that get datasource entries attached (StoryblokPage.duck mutates them).
 */
export const getStoryPresetComponents = (story) => {
  const allContentComponents = (story.content?.content ?? [])
    .flatMap((c) => c?.general_items ?? [])
    .flatMap((item) => item?.general_content ?? []);

  return {
    passPresetComponents: byComponent(allContentComponents, 'pass_preset'),
    passTierPresetComponents: byComponent(allContentComponents, 'pass_tier_cards_preset'),
    passBenefitsPresetComponents: byComponent(allContentComponents, 'pass_benefits_preset'),
  };
};

export const isBlogStory = (story) => story.full_slug.includes('blog');

/**
 * Datasources a Storyblok story requests during SSR, de-duplicated.
 *
 * @param {object} story Storyblok story with content
 * @returns {string[]}
 */
export const getStoryDatasources = (story) => {
  const { passPresetComponents, passTierPresetComponents, passBenefitsPresetComponents } =
    getStoryPresetComponents(story);

  const requiredDatasources = [
    ...(passPresetComponents.length > 0 ? ['pass-preset-data'] : []),
    ...(passTierPresetComponents.length > 0 ? [PRODUCTS_DATASOURCE] : []),
    ...(passBenefitsPresetComponents.length > 0 ? ['pass-vorteilswelt'] : []),
    ...(isBlogStory(story) ? [BLOG_DATASOURCE] : []),
  ];
  return [...new Set(requiredDatasources)];
};
